import { observer } from 'mobx-react';
import { AnalyticsProvider, Grid, GridColumn } from 'telia-front-react';
import React from 'react';

export interface ContentFooterProps {
  children: React.ReactNode;
}

const ContentFooter = ({ children }: ContentFooterProps): JSX.Element => {
  return (
    <AnalyticsProvider group={'Content Footer'}>
      <Grid align={['center-xs']}>
        <GridColumn width={['xs']}>{children}</GridColumn>
      </Grid>
    </AnalyticsProvider>
  );
};

export default observer(ContentFooter);
